export default function EventCardSkeleton() {
  return (
    <div className="rounded-2xl p-6 bg-white/60 border border-white/30 shadow-soft animate-pulse">
      {/* Badges skeleton */}
      <div className="flex gap-2 mb-4">
        <div className="h-6 w-24 bg-[#EDEBE6] rounded-full"></div>
        <div className="h-6 w-32 bg-[#EDEBE6] rounded-full"></div>
      </div>
      
      {/* Title skeleton */}
      <div className="h-8 bg-[#EDEBE6] rounded mb-2 w-3/4"></div>
      
      {/* Description skeleton */}
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-[#EDEBE6] rounded w-full"></div>
        <div className="h-4 bg-[#EDEBE6] rounded w-2/3"></div>
      </div>
      
      {/* Meta skeleton */}
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-[#EDEBE6] rounded w-1/2"></div>
        <div className="h-4 bg-[#EDEBE6] rounded w-2/3"></div>
      </div>
      
      {/* Capacity skeleton */}
      <div className="mb-4">
        <div className="h-4 bg-[#EDEBE6] rounded w-1/3 mb-2"></div>
        <div className="h-2 bg-[#EDEBE6] rounded-full"></div>
      </div>
      
      {/* Button skeleton */}
      <div className="h-11 bg-[#EDEBE6] rounded-[12px]"></div>
    </div>
  );
}
